import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "hello"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("h3", null, "欢迎进入", -1)), _createVNode(_component_el_button, {
    type: "primary"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("Primary")])),
    _: 1
  })]);
}